"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

require("./styles.css");

var _Item = _interopRequireDefault(require("./Item"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var listTypes = ['bullet', 'decimal', 'lower-alpha', 'upper-alpha'];

var List =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(List, _PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var ordered = _this.props.ordered;
      var propNames = ['divided', 'fluid', 'horizontal', 'full'];
      var names = [List.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);

      if (ordered) {
        if (listTypes.some(function (t) {
          return t === ordered;
        })) {
          (0, _lib.addClassName)(names, "ordered-".concat(ordered));
        }
      }

      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "renderData", function () {
      var _this$props = _this.props,
          data = _this$props.data,
          children = _this$props.children,
          itemNode = _this$props.itemNode,
          loading = _this$props.loading,
          loaderNode = _this$props.loaderNode,
          emptyNode = _this$props.emptyNode;

      if (children) {
        return (0, _lib.getRenderProps)(children, {
          data: data,
          loading: loading
        });
      }

      if (loading) {
        if (loaderNode) {
          return (0, _lib.getRenderProps)(loaderNode, {
            data: data
          });
        }
      }

      if ((0, _lib.arrayHasItems)(data) && itemNode) {
        return data.map(itemNode);
      }

      if (emptyNode) {
        return emptyNode;
      }

      return null;
    });

    return _this;
  }

  _createClass(List, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          as = _this$props2.as,
          className = _this$props2.className,
          loading = _this$props2.loading,
          data = _this$props2.data,
          itemNode = _this$props2.itemNode,
          loaderNode = _this$props2.loaderNode,
          emptyNode = _this$props2.emptyNode,
          children = _this$props2.children,
          ordered = _this$props2.ordered,
          divided = _this$props2.divided,
          fluid = _this$props2.fluid,
          horizontal = _this$props2.horizontal,
          full = _this$props2.full,
          rest = _objectWithoutProperties(_this$props2, ["as", "className", "loading", "data", "itemNode", "loaderNode", "emptyNode", "children", "ordered", "divided", "fluid", "horizontal", "full"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      return _react["default"].createElement(Wrapper, _extends({}, rest, {
        className: classNames
      }), this.renderData());
    }
  }]);

  return List;
}(_react.PureComponent);

exports["default"] = List;

_defineProperty(List, "Item", _Item["default"]);

_defineProperty(List, "className", 'MHub-List');

_defineProperty(List, "displayName", 'List');

_defineProperty(List, "propTypes", {
  as: _common.customPropTypes.as,
  className: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  data: _propTypes["default"].arrayOf(_propTypes["default"].any),
  itemNode: _propTypes["default"].func,
  loaderNode: _common.customPropTypes.render,
  emptyNode: _common.customPropTypes.render,
  children: _common.customPropTypes.render,
  ordered: _propTypes["default"].oneOf(listTypes),
  divided: _propTypes["default"].bool,
  fluid: _propTypes["default"].bool,
  horizontal: _propTypes["default"].bool,
  full: _propTypes["default"].bool
});

_defineProperty(List, "defaultProps", {
  as: 'ul',
  className: null,
  loading: false,
  data: [],
  itemNode: function itemNode(item, index) {
    return _react["default"].createElement(_Item["default"], {
      key: index
    }, item);
  },
  loaderNode: null,
  emptyNode: null,
  children: null,
  ordered: null,
  divided: false,
  fluid: false,
  horizontal: false,
  full: false
});